import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalizeFirstLetter',
    standalone: true,
})
export class CapitalizeFirstLetterPipe implements PipeTransform {
    transform(stringToTransform: string): string {
        return `${stringToTransform[0].toUpperCase()}${stringToTransform.slice(1)}`;
    }
}
